module.exports = __webpack_public_path__ + "861642cf977fe5acdff9093344aa5941.svg";